import { Button, Container, Row, Col } from "reactstrap";
import {
  faMoneyCheckAlt,
  faPencil,
  faPlus,
  faQuestion,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import beamerHelp from "./beamerHelp.png";
import contextOverview from "./contextOverview.svg";
import songsheetView from "./songsheetView.png";
import crewLiveMode from "./crewLiveMode.png";
import "react-medium-image-zoom/dist/styles.css";
import Zoom from "react-medium-image-zoom";
import { ContactFormLink } from "./ContactFormLink";
import { ContainerWithHeaderAndMenu } from "../menuandheader/ContainerWithHeaderAndMenu";
import { useTranslation, Trans } from "react-i18next";
import styles from "./Help.module.css";

export function Help() {
  const { t } = useTranslation();
  return (
    <ContainerWithHeaderAndMenu icon={faQuestion} title={t("help.title")}>
      <Container className="py-4">
        {/* FAQ Section */}
        <section className="mb-5">
          <h2 className="h3 border-bottom pb-2 mb-4">{t("help.faq.title")}</h2>

          <h3
            id="was-kann-songship"
            className={`h5 mb-3 ${styles.anchorTarget}`}
          >
            {t("help.faq.whatCanSongshipTitle")}
          </h3>
          <p className="text-muted mb-5">{t("help.faq.whatCanSongshipDesc")}</p>

          <h3 className="h5 mb-3">{t("help.faq.structureTitle")}</h3>
          <Row className="g-4 align-items-center mb-5">
            <Col md={6} className="order-md-2">
              <img
                src={contextOverview}
                className={`img-fluid rounded ${styles.img}`}
                alt={t("help.faq.structureImageAlt")}
              />
            </Col>
            <Col md={6} className="order-md-1">
              <p className="text-muted lh-lg">{t("help.faq.structureDesc")}</p>
            </Col>
          </Row>

          <h3 className="h5 mb-3">{t("help.faq.pricingTitle")}</h3>
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>{t("help.pricing.table.feature")}</th>
                  <th className="text-center">
                    {t("help.pricing.table.free")}
                  </th>
                  <th className="text-center">{t("help.pricing.table.pro")}</th>
                </tr>
              </thead>
              <tbody>
                <tr className="table-secondary">
                  <td colSpan={3}>
                    <strong>{t("help.pricing.sections.manage")}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>
                      <a href="#editSongs">
                        {t("help.pricing.rows.manageSongs")}
                      </a>
                    </p>
                    <small>
                      <Trans
                        i18nKey="help.pricing.rows.manageSongsNotice"
                        components={{
                          ccliLink: (
                            <a
                              href="https://ccli.com/"
                              target="_blank"
                              rel="noreferrer"
                            />
                          ),
                        }}
                      />
                    </small>
                  </td>
                  <td className="text-center text-success fs-5">✓</td>
                  <td className="text-center text-success fs-5">✓</td>
                </tr>
                <tr>
                  <td>
                    <a href="#manageCrews">
                      {t("help.pricing.rows.manageCrews")}
                    </a>
                  </td>
                  <td className="text-center text-success fs-5">✓</td>
                  <td className="text-center text-success fs-5">✓</td>
                </tr>
                <tr>
                  <td>
                    <a href="#manageSongbooks">
                      {t("help.pricing.rows.manageSongbooks")}
                    </a>
                  </td>
                  <td className="text-center text-success fs-5">✓</td>
                  <td className="text-center text-success fs-5">✓</td>
                </tr>
                <tr className="table-secondary">
                  <td colSpan={3}>
                    <strong>{t("help.pricing.sections.live")}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="#createPlaylist">
                      {t("help.pricing.rows.createPlaylist")}
                    </a>
                  </td>
                  <td className="text-center text-success fs-5">✓</td>
                  <td className="text-center text-success fs-5">✓</td>
                </tr>
                <tr>
                  <td>
                    <a href="#showSongsheets">
                      {t("help.pricing.rows.livePlay")}
                    </a>
                  </td>
                  <td className="text-center text-muted">–</td>
                  <td className="text-center text-success fs-5">✓</td>
                </tr>
                <tr>
                  <td>
                    <a href="#sharedMode">
                      {t("help.pricing.rows.sharedMode")}
                    </a>
                  </td>
                  <td className="text-center text-success fs-5">✓</td>
                  <td className="text-center text-success fs-5">✓</td>
                </tr>
                <tr className="table-secondary">
                  <td colSpan={3}>
                    <strong>{t("help.pricing.sections.beamer")}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="#beamLyrics">
                      {t("help.pricing.rows.beamLyrics")}
                    </a>
                  </td>
                  <td className="text-center text-success fs-5">✓</td>
                  <td className="text-center text-success fs-5">✓</td>
                </tr>
                <tr>
                  <td>
                    <a href="#beamLyrics">
                      {t("help.pricing.rows.beamControl")}
                    </a>
                  </td>
                  <td className="text-center text-success fs-5">✓</td>
                  <td className="text-center text-success fs-5">✓</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Features Section */}
        <section className="mb-5">
          <h2 className="h3 border-bottom pb-2 mb-4">
            {t("help.glossary.title")}
          </h2>

          <div className="mb-4">
            <h3 id="editSongs" className={`h5 mb-3 ${styles.anchorTarget}`}>
              {t("help.editSongs.title")}
            </h3>
            <p className="text-muted">
              <Trans
                i18nKey="help.editSongs.desc"
                components={{
                  icon: <FontAwesomeIcon icon={faPencil} className="mx-1" />,
                  italic: <i />,
                }}
              />
            </p>
          </div>

          <div className="mb-4">
            <h3
              id="createPlaylist"
              className={`h5 mb-3 ${styles.anchorTarget}`}
            >
              {t("help.createPlaylist.title")}
            </h3>
            <p className="text-muted mb-3">{t("help.createPlaylist.desc")}</p>
            <ul className="list-unstyled ps-3">
              <li className="mb-2">
                <a href="#beamLyrics">{t("help.createPlaylist.link1")}</a>
              </li>
              <li className="mb-2">
                <a href="#showSongsheets">{t("help.createPlaylist.link2")}</a>
              </li>
            </ul>
            <p className="text-muted">
              <Trans
                i18nKey="help.createPlaylist.desc2"
                components={{
                  icon: <FontAwesomeIcon icon={faPlus} className="mx-1" />,
                  italic: <i />,
                }}
              />
            </p>
          </div>

          <div className="mb-4">
            <h3 id="manageCrews" className={`h5 mb-3 ${styles.anchorTarget}`}>
              {t("help.manageCrews.title")}
            </h3>
            <p className="text-muted">{t("help.manageCrews.desc1")}</p>
            <p className="text-muted">{t("help.manageCrews.desc2")}</p>
          </div>

          <div className="mb-4">
            <h3
              id="manageSongbooks"
              className={`h5 mb-3 ${styles.anchorTarget}`}
            >
              {t("help.manageSongbooks.title")}
            </h3>
            <p className="text-muted">{t("help.manageSongbooks.desc1")}</p>
            <p className="text-muted">{t("help.manageSongbooks.desc2")}</p>
          </div>
        </section>
        <section className="mb-5">
          <h3
            id="beamLyrics"
            className={`h4 border-bottom pb-2 mb-3 ${styles.anchorTarget}`}
          >
            {t("help.beamLyrics.title")}
          </h3>
          <p className="text-muted mb-3">{t("help.beamLyrics.desc")}</p>
          <ol className="ps-4 mb-4">
            {t("help.beamLyrics.steps", { returnObjects: true }).map(
              (step, i) => (
                <li key={i} className="mb-2 text-muted">
                  {step}
                </li>
              ),
            )}
          </ol>
          <div className="text-center">
            <Zoom>
              <img
                src={beamerHelp}
                className={`img-fluid rounded border ${styles.img}`}
                style={{ maxHeight: "400px" }}
                alt={t("help.beamLyrics.title")}
              />
            </Zoom>
          </div>
        </section>

        {/* Shared Mode Section */}
        <section className="mb-5">
          <h3
            id="sharedMode"
            className={`h4 border-bottom pb-2 mb-3 ${styles.anchorTarget}`}
          >
            {t("help.sharedMode.title")}
          </h3>
          <p className="text-muted mb-3">{t("help.sharedMode.desc")}</p>
          <ol className="ps-4 mb-4">
            {t("help.sharedMode.steps", { returnObjects: true }).map(
              (step, i) => (
                <li key={i} className="mb-2 text-muted">
                  {step}
                </li>
              ),
            )}
          </ol>
          <div className="text-center">
            <Zoom>
              <img
                src={crewLiveMode}
                className={`img-fluid rounded border ${styles.img}`}
                style={{ maxHeight: "400px" }}
                alt={t("help.sharedMode.title")}
              />
            </Zoom>
          </div>
        </section>

        {/* Show Songsheets Section */}
        <section className="mb-5">
          <h3
            id="showSongsheets"
            className={`h4 border-bottom pb-2 mb-3 ${styles.anchorTarget}`}
          >
            {t("help.showSongsheets.title")}
          </h3>
          <p className="text-muted mb-3">
            <Trans
              i18nKey="help.showSongsheets.desc"
              components={{ contactFormLink: <ContactFormLink /> }}
            />
          </p>
          <div className="text-center mb-4">
            <Zoom>
              <img
                src={songsheetView}
                className={`img-fluid rounded border ${styles.img}`}
                style={{ maxHeight: "400px" }}
                alt={t("help.showSongsheets.title")}
              />
            </Zoom>
          </div>
          <div>
            <ContactFormLink>
              <Button color="primary">
                <FontAwesomeIcon icon={faMoneyCheckAlt} className="me-2" />
                {t("help.showSongsheets.buyBtn")}
              </Button>
            </ContactFormLink>
          </div>
        </section>

        {/* Support Section */}
        <section className="mb-5">
          <h3 className="h4 border-bottom pb-2 mb-3">
            {t("help.support.title")}
          </h3>
          <p className="text-muted">
            <Trans
              i18nKey="help.support.desc"
              components={{ contactFormLink: <ContactFormLink /> }}
            />
          </p>
        </section>
      </Container>
    </ContainerWithHeaderAndMenu>
  );
}
